import { getRequest, postRequest } from './helper';

export const getLatestBlogsAction = async (data) => {
  const res = await getRequest('blog/getAllBlogs', data);
  return res.data;
};

export const getLatestPressAction = async (data) => {
  const res = await getRequest('getAllPress', data);
  return res.data;
};

export const getLatestVideosAction = async (data) => {
  const res = await getRequest('getAllVideos', data);
  return res.data;
};

export const submitContactDetailsAction = async (data) => {
  const res = await postRequest('user/saveUserData', data);
  return res.data;
};

export const submitInquiryAction = async (data) => {
  const res = await postRequest('saveInquiry', data);
  return res.data;
};


// Home banner section strat
export const getHomeBannerData = async () => {
  const res = await getRequest('home/getHeroBannerData');
  return res.data;
};
// our strategy section start
export const getOurStrategyData = async () => {
  const res = await getRequest('strategy/getStrategyData');
  return res.data;
};
// unitronix explained section start
export const getUnitronixexplainedAction = async () => {
  const res = await getRequest("unitronixexplained");
  return res.data;
}

export const getCryptocurrencyData= async () => {
  const res = await getRequest("cryptocurrencyportfolio/getCryptocurrencydata");
  return res.data;
}

//Empowering Features

export const getEmpoweringFeaturesData= async () => {
  const res = await getRequest("empoweringFeatures");
  return res.data;
}

//How it work

export const getHowItWorkData= async () => {
  const res = await getRequest("howitworks");
  return res.data;
}